import { BaseComponent } from '@app/shared/base/base-component/base-component.component';
import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  Injector,
} from '@angular/core';
import { Form, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { PageHeaderComponentModel } from '@app/shared/interfaces/page-header-component-model';

@Component({
  selector: 'app-brand',
  templateUrl: './brand.component.html',
  styleUrls: ['./brand.component.less'],
})
export class BrandComponent extends BaseComponent implements OnInit {
  @Input() formGroup: FormGroup;
  @Input() mode: string;
  @Input() componentModel: PageHeaderComponentModel;
  @Output() submitChanges: EventEmitter<any> = new EventEmitter();
  record: any;

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    console.log(this.formGroup.controls);
  }

  override submit() {
    super.submit();
    this.submitChanges.emit();
  }

  recordLoaded(record: any) {
    this.record = record;
  }

  beforeSubmit() {}

  cleanRecord(record: any) : any{
    return record;
  }

  static controls(mode: string) {
    const controlsToReturn: any = {};
    if (mode === 'edit') {
      controlsToReturn['Id'] = [null, []];
    }

    controlsToReturn['Name'] = [null, [Validators.required]];
    controlsToReturn['AttributeValues'] = new FormGroup({});
    return controlsToReturn;
  }
}
